import React from "react";
import Customer from "../components/Customer"

const CustomerPage = () => {
  return (
    <>
      <Customer />
    </>
  );
};

export default CustomerPage;
